"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var makeDecoratorDisplayName = function makeDecoratorDisplayName(decoratorName, DecoratingComponent) {
  var decoratingName = DecoratingComponent.displayName || DecoratingComponent.name || 'Component';
  return decoratorName + "(" + decoratingName + ")";
};

var _default = makeDecoratorDisplayName;
exports.default = _default;
module.exports = exports.default;